import { GridApi } from '@ag-grid-community/core';

export function agGridLastSelect(api: GridApi | null | undefined) {
  api?.deselectAll();
  const lastRowIndex = api?.getLastDisplayedRowIndex();
  if (lastRowIndex !== undefined) {
    const rowNode = api?.getDisplayedRowAtIndex(lastRowIndex);
    rowNode?.setSelected(true);
    api?.ensureIndexVisible(lastRowIndex);
  }
  // api.deselectAll();
  // api.selectNode(rowNode, true, false);
  // api.ensureNodeVisible(rowNode);
  // 역순으로 정렬
  // const currentData = this.main.groupGridTempApi?.getDisplayedRowAtIndex(0)?.data || [];
  // const updatedData = [...selectedGroupData, ...currentData];
  // this.main.groupGridTempApi?.setGridOption('rowData', updatedData);
}
